import withdrawalDetail from './withdrawal-detail.vue'

export default withdrawalDetail
